// Legal placeholder content. Plain, non-deceptive copy aligned with the PRD's
// independent-analytics positioning. Replace with reviewed legal text before launch.

export const LEGAL_DISCLAIMER_SHORT =
  "AI First Sports provides independent, AI-assisted sports analysis for informational and entertainment purposes only. We are not affiliated with FIFA, any league, federation, club, or official tournament body. We do not offer betting, gambling, or wagering advice.";

const COMMON_INTRO = (title) =>
  `This ${title} is a placeholder for the AI First Sports MVP and will be replaced with finalised, legally-reviewed text prior to public launch.`;

export const LEGAL_PAGES = {
  terms: {
    slug: "terms",
    title: "Terms of Service",
    updated: "Phase 1 — Draft",
    sections: [
      {
        heading: "1. Acceptance of Terms",
        body: `${COMMON_INTRO("Terms of Service")} By accessing AI First Sports, you agree to use the platform lawfully and acknowledge that all content is provided for informational and entertainment purposes only.`,
      },
      {
        heading: "2. Nature of the Service",
        body: "AI First Sports is an independent AI sports intelligence and media platform. Content, analysis, comparisons, and digests are generated with the assistance of automated systems and may contain inaccuracies. Nothing on this platform constitutes betting, gambling, or financial advice.",
      },
      {
        heading: "3. No Guarantees",
        body: "We make no warranty regarding the accuracy, completeness, or timeliness of any analysis. You should independently verify all information against official sources before relying on it.",
      },
      {
        heading: "4. Intellectual Property",
        body: "The AI First Sports name, logo, and original content are owned by AI First Sports. We do not use official FIFA, league, club, or team marks. Third-party names are referenced only for identification and remain the property of their respective owners.",
      },
      {
        heading: "5. Changes",
        body: "We may update these Terms at any time. Continued use of the platform after changes constitutes acceptance of the revised Terms.",
      },
    ],
  },
  privacy: {
    slug: "privacy",
    title: "Privacy Policy",
    updated: "Phase 1 — Draft",
    sections: [
      {
        heading: "1. Overview",
        body: `${COMMON_INTRO("Privacy Policy")} We respect your privacy and aim to collect only what is necessary to operate and improve the platform.`,
      },
      {
        heading: "2. Information We Collect",
        body: "We may collect email addresses you voluntarily submit to our newsletter, along with basic, anonymised analytics about how the site is used. We do not sell your personal data.",
      },
      {
        heading: "3. Advertising & Third Parties",
        body: "We intend to display advertising (including Google AdSense) and may feature affiliate or sponsored placements. Advertising partners may use cookies to serve relevant ads. See our Cookie Policy for details.",
      },
      {
        heading: "4. Your Choices",
        body: "You may unsubscribe from our newsletter at any time and may control cookies through your browser settings.",
      },
    ],
  },
  disclaimer: {
    slug: "disclaimer",
    title: "Disclaimer",
    updated: "Phase 1 — Draft",
    sections: [
      {
        heading: "Independent Analysis",
        body: "AI First Sports is an independent platform. We are not affiliated with, endorsed by, or sponsored by FIFA, any league, federation, club, broadcaster, or official tournament body.",
      },
      {
        heading: "No Betting or Gambling Advice",
        body: "Nothing on this platform is intended as betting, gambling, or wagering advice or as a prediction of guaranteed outcomes. Content is for informational and entertainment purposes only.",
      },
      {
        heading: "AI-Generated Content",
        body: "Analysis may be produced or assisted by automated and AI systems and can contain errors or omissions. Always verify information against official sources before acting on it.",
      },
      {
        heading: "No Liability",
        body: "AI First Sports accepts no liability for any loss or decision made in reliance on content published on this platform.",
      },
    ],
  },
  "cookie-policy": {
    slug: "cookie-policy",
    title: "Cookie Policy",
    updated: "Phase 1 — Draft",
    sections: [
      {
        heading: "What Are Cookies",
        body: `${COMMON_INTRO("Cookie Policy")} Cookies are small text files stored on your device that help websites function and understand usage.`,
      },
      {
        heading: "How We Use Cookies",
        body: "We may use essential cookies for core functionality, analytics cookies to understand traffic, and advertising cookies (e.g., via Google AdSense) to support free access to our content.",
      },
      {
        heading: "Managing Cookies",
        body: "You can accept, reject, or delete cookies through your browser settings. Disabling some cookies may affect site functionality.",
      },
    ],
  },
  "affiliate-policy": {
    slug: "affiliate-policy",
    title: "Affiliate & Sponsored Content Policy",
    updated: "Phase 1 — Draft",
    sections: [
      {
        heading: "Transparency First",
        body: `${COMMON_INTRO("Affiliate & Sponsored Content Policy")} We believe in clearly distinguishing editorial content from commercial content.`,
      },
      {
        heading: "Affiliate Links",
        body: "Some links on AI First Sports are affiliate links. If you click them and take an action, we may earn a commission at no extra cost to you. This helps keep our core analysis free.",
      },
      {
        heading: "Sponsored & Advertising Placements",
        body: "Sponsored blocks and advertisements are clearly labelled (e.g., 'Advertisement' or 'Sponsored'). We do not present paid placements in a deceptive or misleading way.",
      },
      {
        heading: "Editorial Independence",
        body: "Commercial relationships do not dictate our analysis. Our independent positioning is core to the platform.",
      },
    ],
  },
};

export const LEGAL_LINKS = [
  { label: "Terms of Service", slug: "terms" },
  { label: "Privacy Policy", slug: "privacy" },
  { label: "Disclaimer", slug: "disclaimer" },
  { label: "Cookie Policy", slug: "cookie-policy" },
  { label: "Affiliate Policy", slug: "affiliate-policy" },
];
